module.exports = __webpack_public_path__ + "static/media/footprints.00cb4d01.png";